// extracted by mini-css-extract-plugin
export default {"wish-container":"WishList_wish-container__qq+0a"};